'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _taReactTrackingpixel = require('ta-react-trackingpixel');

var _taReactTrackingpixel2 = _interopRequireDefault(_taReactTrackingpixel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file React component used to display invisible tracking pixel using the
 * WEMF endpoint.
 */

var WemfTracking = function WemfTracking(props) {
  var pixels = [];

  props.trackingUrls.map(function (url) {
    pixels.push(_react2.default.createElement(_taReactTrackingpixel2.default, {
      url: url + '?r=' + encodeURIComponent(document.referrer) + '&d=' + Date.now(),
      key: url }));
  });

  return _react2.default.createElement(
    'span',
    null,
    pixels
  );
};

WemfTracking.propTypes = {
  /**
   * List of Tracking pixel source URLs for use with WEMF tracking.
   */
  trackingUrls: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string).isRequired
};

WemfTracking.defaultProps = {};

exports.default = WemfTracking;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-wemftracking/dist/index.js
// module id = 97
// module chunks = 0